import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'

export const userNotExist = (
  data: GQLForeignRootQuery | undefined
): boolean | undefined => {
  return (
    data && Object.keys(data).length !== 0 && (!data.user || data.user.deleted)
  )
}
